import { StyleSheet } from '@/core/StyleSheet';

export default {
	/**
	 * input[theme=default]
	 */
	default: StyleSheet.create({
		container: {},

		button: {
			alignItems: 'center',
			borderRadius: 10,
			height: 48,
			justifyContent: 'center',
		},

		content: {
			alignItems: 'center',
			flex: 1,
			flexDirection: 'row',
			justifyContent: 'center',
		},

		text: {
			fontFamily: '$fontMedium',
			fontSize: 16,
			fontWeight: '$weightMedium',
		},
	}),

	default__isDisabled: StyleSheet.create({
		button: {
			backgroundColor: '$buttonBackgroundColor__Disabled',
		},
	}),

	/**
	 * input[theme=circular]
	 */
	circular: StyleSheet.create({
		container: {
			alignSelf: 'center',
		},

		button: {
			borderRadius: 24,
			height: 48,
			minWidth: 48,
		},

		content: {
			alignItems: 'center',
			flex: 1,
			flexDirection: 'row',
			justifyContent: 'center',
			paddingHorizontal: '1rem',
		},

		text: {
			fontFamily: '$fontMedium',
			fontSize: 16,
			fontWeight: '$weightMedium',
		},
	}),

	circular__isDisabled: StyleSheet.create({
		button: {
			backgroundColor: '$buttonBackgroundColor__Disabled',
		},
	}),
};
